export default "__VITE_ASSET__d720efbc__"